module.exports = __webpack_public_path__ + "static/media/alcomputer_lg.0416a7b3.jpg";